import React from 'react';

import { Skeleton as SkeletonMui, styled } from '@mui/material';

import { skeletonStyles } from './styles';

export const Skeleton = styled(({ ...props }) => (
  <SkeletonMui variant="rectangular" {...props} />
))(skeletonStyles);
